var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { persistentKVStore } from '../../../../../infra/persistence';
import { SessionQuery } from '../../../../../infra/session/session-query';
import { confirmUserLogin } from '../../../login/actions/confirm-user-login';
export var handleVerifyCode = function (_a) {
    var setStatus = _a.setStatus, setIsLockedOut = _a.setIsLockedOut, validateCode = _a.validateCode, verificationType = _a.verificationType, code = _a.code, redirectObject = _a.redirectObject, dispatch = _a.dispatch, navigate = _a.navigate;
    return __awaiter(void 0, void 0, void 0, function () {
        var validateResponse_1, fullUserData_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    setStatus('pending');
                    return [4 /*yield*/, validateCode(verificationType, code)];
                case 1:
                    validateResponse_1 = _b.sent();
                    if (!validateResponse_1.token) return [3 /*break*/, 3];
                    setStatus('success');
                    // fetch full user data, since initially we only get partial data enough for 2FA check only
                    persistentKVStore.setItem('token', validateResponse_1.token);
                    return [4 /*yield*/, new SessionQuery().request()];
                case 2:
                    fullUserData_1 = _b.sent();
                    setTimeout(function () {
                        confirmUserLogin({
                            user: fullUserData_1,
                            token: validateResponse_1.token,
                            redirectObject: redirectObject,
                            dispatch: dispatch,
                            navigate: navigate,
                        });
                    }, 1000);
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    setStatus('fail');
                    if (error_1.status === 403 && error_1.code === 'auth.mfa.locked') {
                        setIsLockedOut(true);
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
};
